/* istanbul ignore file */
import { Box } from '@cambridgeassessment/cambridge-ui';
import React, {
  memo,
  ReactChild,
  ReactChildren,
  ReactNode,
  useCallback,
  useState,
} from 'react';
import useWindowDimensions from 'src/hooks/useWindowDimensions';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Notifications from '../Notifications/Notifications';
import Sidebar from '../Sidebar/Sidebar';
import GlobalHeader, { screenSize } from './GlobalHeader';
import { useStyles } from './styles';

interface AuthenticatedLayoutProps {
  children?: ReactNode | ReactChild | ReactChildren | any;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
}) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const showSidebar = useCallback(() => setSidebarOpen(true), []);
  const hideSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <Box className={classes.app}>
      <Box id="mainContainer" className={classes.mainContainer}>
        {width > 1024 && <GlobalHeader size={screenSize.Desktop} />}
        <Header onToggleSidebar={showSidebar} isAuthenticated />
        <Box className={classes.pageContainer}>
          <Sidebar
            show={sidebarOpen}
            hideSidebar={hideSidebar}
            className={classes.sidebarContainer}
          />
          <Box className={classes.contentAndFooterContainer}>
            <Box className={classes.contentContainer}>
              <Notifications />
              {children}
            </Box>
            <Footer />
            {width < 1025 && <GlobalHeader size={screenSize.Mobile} />}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(AuthenticatedLayout);
